import styled from 'styled-components';
import mediaQueries from './constants/mediaQueries';

const Container = styled.div`
  margin: 0 auto;
  max-width: ${({ minWidth }) => minWidth || '100%'};

  ${mediaQueries.desktop`
    padding-top: ${({ topPadding }) => topPadding || '24px'};
  `}

  ${mediaQueries.mobile`
    padding-top: 16px;
  `}
`;

export default Container;
